import SystemNeoUmmiaLogoTextImage from "../../images/SystemNeoUmmiaLogoTextImage";
import {internalRoutes} from "../../../constants/internalRoutes";
import PreviewScreenTitleText from "../../texts/previewScreens/PreviewScreenTitleText";
import PreviewDevicePicker from "../../others/previewScreens/PreviewDevicePicker";
import {useNavigate} from "react-router-dom";
import PreviewCorrectionSwitcher from "../../others/previewScreens/PreviewCorrectionSwitcher";
import PreviewExerciserUserCard from "../../cards/previewScreen/PreviewExerciserUserCard";
import PreviewQuestionAssignmentText from "../../texts/previewScreens/PreviewQuestionAssignmentText";
import PreviewAppVersionNumber from "../../others/previewScreens/PreviewAppVersionNumber";

export default function PreviewQuestionSideBar({displayCorrection, toggleView, question, device, setDevice}) {
    // Used in PreviewQuestionScreen to display screen top bar
    // with app logo, correction switcher and device picker

    // PROPERTIES
    const navigate = useNavigate();

    // BUILD
    return (
        <aside className={"bg-backgroundLight1 w-[232px] min-w-[232px] h-full flex flex-col justify-start items-center border-r-[1px] border-greyLight3"}>
            <div className={"w-full flex flex-col justify-start items-center"}>
                <div className={"w-full flex flex-col justify-start items-start px-[12px] pt-[10px] pb-[12px] border-b-[1px] border-greyLight3"}>
                    <div className={"w-full flex justify-start items-center space-x-[12px]"}>
                        <SystemNeoUmmiaLogoTextImage onLogoPressed={() => navigate(internalRoutes.home)}
                                                     extraClass={"mt-[2px]"}/>
                        <PreviewAppVersionNumber />
                    </div>
                        <PreviewScreenTitleText title={"Question (" + question?.id + ")"}
                                                extraClass={"text-white"} />
                </div>
                <div className={"mt-[16px] w-full flex flex-col px-[16px]"}>
                    <PreviewDevicePicker device={device}
                                         setDevice={setDevice} />
                    <PreviewCorrectionSwitcher displayCorrection={displayCorrection}
                                               toggleView={toggleView} />
                </div>
            </div>
            <div className={"mb-[16px] w-full grow flex flex-col space-y-[16px] justify-between items-center px-[16px]"}>
                <PreviewQuestionAssignmentText />
                <PreviewExerciserUserCard />
            </div>
        </aside>
    );
}